/** Mirror an already committed merge. Identity decisions belong to PostgreSQL. */
export async function mirrorCompanyMerge(db, result) {
    const keepId = result?.keepId;
    const mergeId = result?.mergeId;
    const updates = result?.cacheUpdates;
    if (!result?.ok || !keepId || !mergeId || !updates?.companies || !updates?.contacts) {
        throw new Error('A confirmed server merge is required to update the client cache.');
    }
    const tables = ['companies', 'crm_contacts', 'projects', 'properties', 'company_addresses', 'crm_activities', 'crm_insights'];
    await db.transaction('rw', tables.map(name => db[name]), async () => {
        // Both spellings exist in older browser caches. Update them together and
        // leave quote content and its concurrency receipt untouched.
        for (const table of ['projects', 'properties', 'company_addresses', 'crm_activities']) {
            const rows = await db[table].toArray();
            for (const row of rows) {
                if ((row.companyId ?? row.company_id) === mergeId) {
                    await db[table].update(row.id, { companyId: keepId, company_id: keepId });
                }
            }
        }
        for (const row of await db.crm_insights.toArray()) {
            if ((row.scopeType ?? row.scope_type) === 'company' && (row.scopeId ?? row.scope_id) === mergeId) {
                await db.crm_insights.update(row.id, { scopeId: keepId, scope_id: keepId });
            }
        }
        for (const row of updates.companies) {
            await db.companies.put({ ...row,
                is_active: row.isActive ?? row.is_active,
                merged_into_company_id: row.mergedIntoCompanyId ?? row.merged_into_company_id ?? null,
            });
        }
        for (const row of updates.contacts) {
            await db.crm_contacts.put({ ...row,
                company_id: row.companyId ?? row.company_id,
                is_active: row.isActive ?? row.is_active,
                is_primary: row.isPrimary ?? row.is_primary,
                merged_into_contact_id: row.mergedIntoContactId ?? row.merged_into_contact_id ?? null,
            });
        }
    });
    return result;
}
